import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
	static targets = ["button", "content", "icon"];
	static values = {
		closeOthers: {
			type: Boolean,
			default: false,
		},
		group: String,
		open: {
			type: Boolean,
			default: false,
		},
	};

	connect() {
		this.handleAccordionOpened = this.handleAccordionOpened.bind(this);
		document.addEventListener("custom-accordion:opened", this.handleAccordionOpened);
		this.update();
	}

	disconnect() {
		document.removeEventListener("custom-accordion:opened", this.handleAccordionOpened);
	}

	toggle(event) {
		event?.preventDefault();
		this.openValue = !this.openValue;
		this.update();

		if (this.openValue) {
			this.notifyOpened();
		}
	}

	open() {
		this.openValue = true;
		this.update();
		this.notifyOpened();
	}

	close() {
		this.openValue = false;
		this.update();
	}

	update() {
		this.contentTarget.classList.toggle("hidden", !this.openValue);

		if (this.hasButtonTarget) {
			this.buttonTarget.setAttribute("aria-expanded", String(this.openValue));
			this.buttonTarget.setAttribute("aria-controls", this.contentTarget.id);
		}

		this.contentTarget.setAttribute("aria-hidden", String(!this.openValue));

		if (this.hasIconTarget) {
			this.iconTarget.classList.toggle("rotate-180", this.openValue);
		}
	}

	handleAccordionOpened(event) {
		if (!this.closeOthersValue || !this.hasGroupValue) {
			return;
		}

		if (event.detail.source === this.element) {
			return;
		}

		if (event.detail.group !== this.groupValue) {
			return;
		}

		this.close();
	}

	notifyOpened() {
		if (!this.closeOthersValue || !this.hasGroupValue) {
			return;
		}

		document.dispatchEvent(
			new CustomEvent("custom-accordion:opened", {
				detail: {
					group: this.groupValue,
					source: this.element,
				},
			})
		);
	}
}
